import { actions, endpoints } from '../../../utils/constants';
import { Notification } from '../../components/index';
import { put, all, takeEvery, select, call } from 'redux-saga/effects';
import { Post, CheckIfHasEmpty, Get } from '../../../utils/functions';
import { getHeader } from '../admin/admin.saga';
import { history } from '../../../config/redux-store';

const loginKeys = ['password', 'username'];

function* doLogin() {
  const { password, username } = yield select(state => state.login.form);
  yield put({ type: actions.TOOGLE_REQUESTING, payload: true });
  try {
    const args = { username, password, grant_type: 'password' }
    const { status, data } = yield call(Post, endpoints.login, args)
    if (status === 200) {
      sessionStorage.setItem('token', data.access_token);
      sessionStorage.setItem('user_id', data.user_id);
      yield put({ type: actions.SET_TOKEN, payload: data.access_token });
      // yield history.push('/dashboard/statistics');
      yield put({ type: actions.TOOGLE_REQUESTING, payload: false });
      yield put({ type: actions.RESET_FORMS });
    }
  } catch (e) {
    yield put({ type: actions.TOOGLE_REQUESTING, payload: false });
    yield Notification('error', 'Erro', 'Não foi possivel efetuar o login');
  }
}

function* getUserLogged() {
  try {
    yield put({ type: actions.CHANGE_USER_LOGGED_LOADING, payload: true });
    const header = yield getHeader();
    const user_id = sessionStorage.getItem('user_id');
    const { data } = yield call(Get, `${endpoints.userInfo}/${user_id}`, header);
    yield put({ type: actions.CHANGE_USER_LOGGED, payload: data });
  } catch (error) {
    yield Notification('error', 'Erro ao carregar usuário!', error.message);
  } finally {
    yield put({ type: actions.CHANGE_USER_LOGGED_LOADING, payload: false });
  }
}

function* changeFormValue(action) {
  const { id, value } = action.payload;
  yield put({ type: actions.CHANGE_LOGIN_FORM, payload: { id, value } })
  const current = yield select(state => state.login.form);
  yield put({ type: actions.TOOGLE_DISABLE, payload: !CheckIfHasEmpty(current, loginKeys) });
}

function* checkIsEnter({ type, payload }) {
  if (payload === 'Enter') {
    const { password, username } = yield select(state => state.login.form);
    if ((password && password !== '') && (username && username !== '')) {
      yield put({ type: actions.ASYNC_LOGIN });
    }
  }
}

export default function* LoginSaga() {
  yield all([
    yield takeEvery(actions.ASYNC_CHANGE_LOGIN_FORM, changeFormValue),
    yield takeEvery(actions.ASYNC_LOGIN, doLogin),
    yield takeEvery(actions.CHECK_IF_ENTER, checkIsEnter),
    yield takeEvery(actions.ASYNC_GET_USER_LOGGED, getUserLogged)
  ])
}


// WEBPACK FOOTER //
// ./src/App/containers/login/login.saga.js